export default __webpack_public_path__ + "static/logo-edufun-0d1d3484789b55fd5f6592f899fdeca9.png";